import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${p => p.width};
  height: ${p => p.height};
  cursor: pointer;
  pointer-events: all;

  > div {
    background: ${p => p.color};
  }

  @media (max-width: 767px){
    transform: scale(.62);
  }
`

export const Line = styled.div`
  width: 100%;
  height: 1px;
`